import z from 'zod';

import { AwardVouchersWithExpirationDaysSchema } from '@occc/validation';
import { ProductChallengeFormValues } from '@occc-app/routes/Challenge/types';

import {
  DraftSweepstakesSchema,
  PointSpendEarningMechanismSchema,
  ProductPurchaseEarningMechanismSchema,
  ProductPurchaseFormSchema,
  RewardFormSchema,
  SpendBonusEarningMechanismSchema,
  SpendBonusFormSchema,
  VarietyChallengeFormSchema,
} from './schemas';

export enum SweepstakesType {
  ProductPurchase = 'productPurchase',
  VarietyChallenge = 'varietyChallenge',
  SpendBonus = 'spendBonus',
  Reward = 'reward',
}

export type SweepstakesAwardVouchersFormValues = z.infer<
  typeof AwardVouchersWithExpirationDaysSchema
>;

export type ProductPurchaseFormValues = z.infer<typeof ProductPurchaseEarningMechanismSchema>;
export type SpendBonusFormValues = z.infer<typeof SpendBonusEarningMechanismSchema>;
export type PointSpendFormValues = z.infer<typeof PointSpendEarningMechanismSchema>;
export type VarietyChallengeFormValues = ProductChallengeFormValues;

type DraftSweepstakesFormValues = z.infer<typeof DraftSweepstakesSchema>;
type ProductPurchaseFullFormValues = z.infer<typeof ProductPurchaseFormSchema>;
type VarietyChallengeFullFormValues = z.infer<typeof VarietyChallengeFormSchema>;
type SpendBonusFullFormValues = z.infer<typeof SpendBonusFormSchema>;
type RewardFullFormValues = z.infer<typeof RewardFormSchema>;

export type SweepstakesConfigureFormValues =
  | DraftSweepstakesFormValues
  | ProductPurchaseFullFormValues
  | VarietyChallengeFullFormValues
  | SpendBonusFullFormValues
  | RewardFullFormValues;

export type SweepstakesConfigureFormInitialValues = Partial<SweepstakesConfigureFormValues>;

type WithAwardVouchers = { awardVouchers?: SweepstakesAwardVouchersFormValues };

export type SweepstakesEarningMechanismInitialValues =
  | { sweepstakesType?: undefined }
  | (Pick<ProductPurchaseFullFormValues, 'sweepstakesType' | 'productPurchase'> & WithAwardVouchers)
  | (Pick<VarietyChallengeFullFormValues, 'sweepstakesType' | 'productChallenge'> &
      WithAwardVouchers)
  | (Pick<SpendBonusFullFormValues, 'sweepstakesType' | 'spendBonus'> & WithAwardVouchers)
  | (Pick<RewardFullFormValues, 'sweepstakesType' | 'pointSpend'> & WithAwardVouchers);
